<template>
<w-sliding-popup ref="slidingPopup" type="setting" :title="title" @close="onClose" width="500px">
  <div slot="content">
    <el-form :model="eventFormData" label-position="top" ref="eventForm" :rules="rules">
      <div class="title-h4">자원 정보</div>
      <el-row>
        <el-form-item label="관리구분" prop="managetypeId">
          <el-select v-model="eventFormData.managetypeId" style="width:100%" disabled>
            <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="자원구분" prop="rsctypeId">
            <el-select v-model="eventFormData.rsctypeId" style="width:100%" disabled>
              <el-option v-for="item in rsctypeList" :key="item.rsctypeId" :label="item.rsctypeName" :value="item.rsctypeId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="자원" prop="rscId">
            <el-select v-model="eventFormData.rscId" style="width:100%" :disabled="isRsc || !isAddMode">
              <el-option v-for="item in rscList" :key="item.rscId" :label="item.rscName" :value="item.rscId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="mr-t25 title-h4">기본 정보</div>
      <el-row>
        <el-form-item label="이벤트 ID" prop="eventId">
          <el-input v-model="eventFormData.eventId" :disabled="!isAddMode"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="이벤트 메시지" prop="eventMessage">
          <el-input v-model="eventFormData.eventMessage" ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="이벤트 등급" prop="eventlevelId">
          <el-select v-model="eventFormData.eventlevelId" style="width:100%" :disabled="!isAddMode" @change="onEventlevelChange">
            <el-option v-for="item in eventlevelListWithNM" :key="item.eventlevelId" :label="item.eventlevelName" :value="item.eventlevelId"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="이벤트 판단조건" prop="eventCondition">
          <el-input v-model="eventFormData.eventCondition" :disabled="!isAddMode"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="판단순위" prop="eventJudgePriority">
            <el-input-number v-model="eventFormData.eventJudgePriority" :disabled="eventFormData.eventlevelId === 'NM'" controls-position="right" :min="1" style="width:100%;"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="isAddMode">
          <el-form-item label="적용" prop="defaultapplyFlag">
            <el-switch v-model="eventFormData.defaultapplyFlag" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="장애 티켓" prop="troubleTicketApplyFlag">
            <el-switch v-model="eventFormData.troubleTicketApplyFlag" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" @click="onSavenButtonClick">저장</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import ResourceAPI from '@/api/model/rsc';
import msgUtil from '@/utils/message';
import EventSettingsAPI from '@/api/settings/common/event-settings';

export default {
  name: 'WCommonEventPopup',
  props: {
    managetypeList: Array,
  },
  computed: mapGetters(['eventlevelListWithNM']),
  data() {
    return {
      isAddMode: true,
      isRsc: false,
      title: '이벤트 추가',
      rscData: null,
      rsctypeList: [],
      rscList: [],
      eventFormData: {},
      rules: {
        eventId: {
          required: true,
          validator: this.validateEventId,
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    /**
     * 이벤트 편집 팝업을 연다.
     * @author Ju
     * @param  {[type]} rscData   [description]
     * @param  {[type]} eventData [description]
     * @return {[type]}           [description]
     */
    open(rscData, eventData) {
      this.rscData = rscData;
      this.isRsc = this.rscData.type === 'rsc';
      this.loadRsctype();
      this.loadRsc();
      if (isNil(eventData)) {
        this.isAddMode = true;
        this.title = '이벤트 추가';
        this.eventFormData = {
          managetypeId: rscData.managetypeId,
          rsctypeId: rscData.rsctypeId,
          rscId: this.isRsc ? rscData.rscId : null,
          defaultapplyFlag: '1',
          troubleTicketApplyFlag: '1',
          eventlevelId: Object.values(this.eventlevelListWithNM)[0].eventlevelId,
        };
      } else {
        this.isAddMode = false;
        this.title = '이벤트 수정';
        this.eventFormData = eventData;
      }
      this.$refs.slidingPopup.open();
    },
    /**
     * 이벤트 편집 팝업을 닫는다.
     * @author Ju
     * @return {[type]} [description]
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 팝업 close 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onClose() {
      this.$refs.eventForm.resetFields();
    },
    /**
     * 관리 구분에 대한 자원 구분 목록을 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadRsctype() {
      ResourceAPI.getRsctypeList({
        managetypeId: this.rscData.managetypeId,
      })
        .then((response) => {
          if (response.data.success) {
            this.rsctypeList = isNil(response.data.data) ? [] : response.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 구분 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 구분 정보', false));
        });
    },
    /**
     * 관리구분/자원 구분에 대한 자원 목록을 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadRsc() {
      ResourceAPI.getRscList({
        managetypeId: this.rscData.managetypeId,
        rsctypeId: this.rscData.rsctypeId,
      })
        .then((response) => {
          if (response.data.success) {
            this.rscList = isNil(response.data.data) ? [] : response.data.data;
            if (this.isAddMode && !this.isRsc && this.rscList.length > 0) {
              this.eventFormData.rscId = this.rscList[0].rscId;
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 구분 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 구분 정보', false));
        });
    },
    /**
     * 저장 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onSavenButtonClick() {
      this.$refs.eventForm
        .validate()
        .then((valid) => {
          if (valid) {
            const target = '이벤트';
            if (this.isAddMode) {
              // 추가
              const action = msgUtil.action.ADD;
              EventSettingsAPI.insertEvent(this.eventFormData).then((response) => {
                if (response.data.success) {
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.close();
                  this.$emit('re-load');
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
            } else {
              // 수정
              const action = msgUtil.action.SAVE;
              EventSettingsAPI.updateEvent(this.eventFormData).then((response) => {
                if (response.data.success) {
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.close();
                  this.$emit('re-load');
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
            }
          }
        })
        .catch(() => {
          this.$message(msgUtil.getCustomMsgData('값을 설정해주십시오.'));
        });
    },
    /**
     * 이벤트 등급 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onEventlevelChange(value) {
      if (value === 'NM') {
        this.eventFormData.eventJudgePriority = 999;
      }
    },
    /**
     * 이벤트 아이디 중복 여부를 검사한다.
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateEventId(rule, value, callback) {
      if (!this.isAddMode) {
        callback();
      } else if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else {
        EventSettingsAPI.checkEventIdValidation({
          managetypeId: this.eventFormData.managetypeId,
          rsctypeId: this.eventFormData.rsctypeId,
          rscId: this.eventFormData.rscId,
          eventId: value,
        }).then((response) => {
          if (response.data.success) {
            if (response.data.data) {
              callback();
            } else {
              callback(new Error('이미 사용 중인 ID입니다.'));
            }
          } else {
            callback('이벤트 아이디 중복 여부를 확인하지 못하였습니다.');
          }
        }).catch(() => {
          callback('이벤트 아이디 중복 여부를 확인하지 못하였습니다.');
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/popup/CommonEventPopup.vue